var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAssortmentLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7251A",
    fillRule: "evenodd",
    d: "M22.2669683,15.1264755 L22.2669683,7.38617201 C22.2669683,3.30688027 19.0133575,0 15,0 C10.986543,0 7.73303167,3.30688027 7.73303167,7.38617201 L7.73303167,15.1264755 L11.4162896,15.1264755 L11.4162896,7.38617201 C11.4162896,5.37450253 13.0207964,3.74367622 15,3.74367622 C16.9792036,3.74367622 18.5837104,5.37450253 18.5837104,7.38617201 L18.5837104,15.1264755 L4,15.1264755 L4,30 L26,30 L26,15.1264755 L22.2669683,15.1264755 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssortmentLock);
export default __webpack_public_path__ + "static/media/icon_assortment_lock.f5c14651.svg";
export { ForwardRef as ReactComponent };